import React from "react";
import PaymentCheckRowActions from "./PaymentCheckRowActions";
import { Button } from "../ui/button";

interface PaymentCheck {
  id: string;
  payeeName: string;
  payeeType: string;
  checkNumber: number;
  totalAmount: string;
  status: string;
  issueDate?: string | null;
  batchStatus?: "DRAFT" | "FINALIZED";
  notes?: string;
}

export interface PaymentCheckTableProps {
  checks?: PaymentCheck[];
  isLoading?: boolean;
  error?: Error | null;
  onSelectCheck?: (id: string) => void;
}

const PaymentCheckTable: React.FC<PaymentCheckTableProps> = ({
  checks = [],
  isLoading,
  error,
  onSelectCheck,
}) => {
  if (isLoading) {
    return (
      <div className="border rounded mb-4 p-4">Loading payment checks...</div>
    );
  }
  if (error) {
    return (
      <div className="border rounded mb-4 p-4 text-destructive">
        Error loading payment checks: {error.message}
      </div>
    );
  }
  return (
    <table className="w-full border rounded mb-4">
      <thead>
        <tr>
          <th className="p-2 text-left">Check #</th>
          <th className="p-2 text-left">Payee</th>
          <th className="p-2 text-left">Type</th>
          <th className="p-2 text-left">Amount</th>
          <th className="p-2 text-left">Status</th>
          <th className="p-2 text-left">Issue Date</th>
          <th className="p-2 text-left">Actions</th>
        </tr>
      </thead>
      <tbody>
        {checks.length === 0 ? (
          <tr>
            <td colSpan={7} className="p-4 text-center text-muted">
              No checks found.
            </td>
          </tr>
        ) : (
          checks.map((check) => (
            <tr key={check.id} className="border-b">
              <td className="p-2">{check.checkNumber}</td>
              <td className="p-2">{check.payeeName}</td>
              <td className="p-2">{check.payeeType}</td>
              <td className="p-2">${check.totalAmount}</td>
              <td className="p-2">{check.status}</td>
              <td className="p-2">
                {check.issueDate
                  ? new Date(check.issueDate).toLocaleDateString()
                  : "-"}
              </td>
              <td className="p-2">
                <div className="flex gap-2 items-center">
                  <Button
                    className="btn btn-xs btn-outline"
                    onClick={() => onSelectCheck?.(check.id)}
                  >
                    Details
                  </Button>
                  <PaymentCheckRowActions
                    checkId={check.id}
                    status={check.status as "CREATED" | "PAID"}
                    batchStatus={check.batchStatus ?? "DRAFT"}
                  />
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export default PaymentCheckTable;
